<template>
  <div class="conten">
    <div class="consj_heads">
      <div class="conta_img">
        <img src="@/assets/20200729135846.png" alt="" />
      </div>
      <div class="conta_con">
        <b>{{ title }}业务管理平台</b>
      </div>
      <div class="con_heads">
        <el-tooltip content="点击可以修改登录密码哦" placement="top">
          <h3 @click="modify">{{ name }}</h3>
        </el-tooltip>
        <el-dialog
          title="修改密码"
          :visible.sync="dialogVisible"
          width="50%"
          :before-close="handleClose"
        >
          <div class="mod">
            <div class="modify">
              <span>账号：{{ name }}</span>
            </div>

            <div class="modify">
              <span>修改密码：</span>
              <el-input
                maxlength="11"
                placeholder="请输入要修改的密码"
                v-model="input"
                show-password
                class="mod_input"
              ></el-input>
            </div>
          </div>
          <span class="text"
            >*注意*：账号不可修改，密码可以自行更改，密码类型为数字、字母、符号，最长不超过11位数</span
          >
          <span slot="footer" class="dialog-footer">
            <el-button @click="reset">ResetToken</el-button>
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="dialogs">确 定</el-button>
          </span>
        </el-dialog>
        <div class="conta_text">
          <b @click="loginOut">退出</b>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  inject: ["reload"],
  name: "heads",
  data() {
    return {
      name: "", //账户用户名
      images: "", //账户头像
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      token: "", //token
      id: "", //当前登录账号的id

      dialogVisible: false, //修改密码功能默认关闭
      input: "", //要修改密码的值
      title: "", //当前登录的典当行名称
    };
  },
  methods: {
    //退出登录操作
    loginOut() {
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("id");
          window.location.href = "/";
        })
        .catch(() => {});
    },

    //点击修改账号密码
    modify() {
      this.dialogVisible = !this.dialogVisible;
    },

    //提交修改密码
    dialogs() {
      this.axios
        .post("/getUser/SetUsers", {
          data: {
            _id: sessionStorage.getItem("userId"),
            password: this.input,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.$notify({
              title: "成功",
              message: "密码修改成功，请重新登录",
              type: "success",
            });

            setTimeout(() => {
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("userId");
              sessionStorage.removeItem("id");

              window.location.href = "/";
            }, 1000);
          }
        });
    },

    //关闭窗口执行
    handleClose() {
      this.input = "";
      this.dialogVisible = false;
    },

    //通过token请求用户
    // getUser() {
    //   // this.axios
    //   //   .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
    //   //     env: "changan2020-qtz0s",
    //   //     query: 'db.collection("userdatas").where({token:"' + this.token + '"}).get()',
    //   //   })
    //   //   .then((rs) => {
    //   //     if (rs.data.errcode == 0) {
    //   //       rs.data.data.forEach((element, index, array) => {
    //   //         array[index] = JSON.parse(element);
    //   //       });
    //   //       this.name = rs.data.data[0].name;
    //   //       this.id = rs.data.data[0]._id;
    //   //     } else {
    //   //         this.$notify.error({
    //   //         title: '错误提示',
    //   //         message: '密钥过期啦，请刷新页面'
    //   //       });
    //   //     }
    //   //   });
    //   this.axios.post("/getUser/Users",{data:{
    //       tokenId:this.token
    //   }}).then(res=>{
    //     if(res.data.length == 1){
    //       this.name = res.data[0].username,
    //       this.title = res.data[0].title
    //     }else{
    //       this.$message.error("登录账户异常，请重新登录或联系管理员");
    //     }
    //   })

    // },

    //重置密钥
    reset() {
      this.axios
        .post("/getUser/getToken", {
          data: {
            eid: sessionStorage.getItem("id"),
          },
        })
        .then((res) => {
          this.axios
            .post("/getUser/SetSecret", {
              data: {
                id: sessionStorage.getItem("id"),
                token: this.ACCESS_TOKEN,
                time: dayjs(res.data[0].time)
                  .subtract(3, "hour")
                  .format("YYYY-MM-DD HH:mm:ss"),
              },
            })
            .then(() => {
              this.$notify({
                title: "密钥重置成功",
                message: dayjs().format("YYYY-MM-DD HH:mm:ss") + "密钥已重置成功",
                type: "success",
              });

              setTimeout(() => {
                this.$router.go(0);
              }, 500);
            });
        });
    },

    //请求到当前典当行的信息
    getInfoData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("info_ddh").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.$store.dispatch("changeDispatch", res.data.data[0]);
        });
    },
  },
  created() {
    //判断 ACCESS_TOKEN 是否过期
    this.getTokens();

    this.axios
      .post("/getUser/getToken", {
        data: {
          eid: sessionStorage.getItem("id"),
        },
      })
      .then((res) => {
        if (dayjs().diff(dayjs(res.data[0].time), "hour") < 2) {
          //小于2小时，有效期内
          this.ACCESS_TOKEN = res.data[0].AccessToken;
        } else {
          //过期啦，重新请求
          this.axios
            .post("/getUser/Users", {
              data: {
                Id: sessionStorage.getItem("userId"),
              },
            })
            .then((res) => {
              this.setTokens(res.data[0].appid, res.data[0].secret);
              setTimeout(() => {
                this.$router.go(0);
              }, 1000);
            });
        }
      });

    // //token
    // this.token = sessionStorage.getItem("token")

    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.title = this.userData.title;
      this.name = this.userData.username;
      this.getInfoData();
    }, 800);

    // console.log("我触发了");
  },
};
</script>
<style scoped>
/* logo */
.conta_img {
  /* margin: 15px 0; */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.conta_img img {
  width: 90px;
  height: 90px;
  border-radius: 10px;
}
.conta_text {
  color: #ffffff;
  margin: 0 15px;
}
.conta_con {
  color: #ffffff;
  font-size: 30px;
  text-align: center;
  /* margin: 15px; */
}
.con_heads {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ffffff;
}

.mod {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 0 auto;
}
.modify {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
}
.mod_input {
  width: 50%;
}
.text {
  color: red;
}

/* 改版头部样式 */
.conten {
  width: 90%;
  height: 10%;
  margin: 0 auto;
}
.consj_heads {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  margin: 0 20px;
}
</style>
